import Button from '@material-ui/core/Button';
import React, { useRef } from 'react';
import { QRCode } from 'react-qr-svg';
import { saveSvgAsPng } from 'save-svg-as-png/lib/saveSvgAsPng';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const QRDownloadButtons = styled.div`
  padding: 7px 12px !important;
  @media (max-width: 480px) {
    flex-direction: 'row';
    justify-content: 'space-between';
  }
`;

const SvgButton = styled.button`
  @media (max-width: 480px) {
    margin-bottom: 10px;
  }
`;

const QRDownloader = ({ url }) => {
  const qrRef = useRef();

  const forceDownload = (href, name) => {
    let link = document.createElement('a');
    link.download = name;
    link.style.opacity = '0';
    link.display = 'none';
    document.body.append(link);
    link.href = href;
    link.click();
    link.remove();
  };

  const downloadPng = () => {
    if (!qrRef.current || !qrRef.current.firstChild) {
      return;
    }

    const svgElement = qrRef.current.firstChild;
    saveSvgAsPng(svgElement, 'tabb-qr.png', { scale: 20.6868686869 });
  };

  const downloadSvg = () => {
    if (!qrRef.current || !qrRef.current.firstChild) {
      return;
    }

    const svgEl = qrRef.current.firstChild;
    const svgData = 'data:image/svg+xml;base64,' + window.btoa(svgEl.outerHTML);
    forceDownload(svgData, 'tabb-qr.svg');
  };

  return (
    <Container>
      <div ref={qrRef}>
        <QRCode
          bgColor="#FFFFFF"
          fgColor="#000000"
          level="Q"
          style={{ width: 70, height: 70, marginRight: 20 }}
          value={url}
        />
      </div>
      <QRDownloadButtons>
        <SvgButton
          onClick={downloadSvg}
          style={{ marginRight: 5 }}
          className="fatsoma__cta__secondary fatsoma__cta__secondary__slim"
        >
          Download SVG
        </SvgButton>
        <Button
          onClick={downloadPng}
          className="fatsoma__cta__secondary fatsoma__cta__secondary__slim"
        >
          Download PNG
        </Button>
      </QRDownloadButtons>
    </Container>
  );
};

export default QRDownloader;



// WEBPACK FOOTER //
// ./src/components/Utility/QRDownloader/index.jsx